<template>
    <div class="expositionCom powerStation">
        <div class="com-left flex justify-between">
            <left-1 />
            <left-2 />
        </div>
        <div class="com-main flex justify-between">
            <goBack />
            <center @backData="backData" />
            <!-- <center-2 /> -->
        </div>
        <div class="com-right">
            <right-1 />
        </div>
    </div>
</template>

<script>
import Map2D from "@/views/vehicle/components/map/2dMap"
import Map3D from '@/views/vehicle/components/map/3dMap'

import goBack from './../exposition/components/goBack'
import left1 from './../exposition/components/powerStationNew/left-1'
import left2 from './../exposition/components/powerStationNew/left-2'
import center from './../exposition/components/powerStationNew/center'
// import center2 from './../exposition/components/powerStation/center-2'
import right1 from './../exposition/components/powerStationNew/right-1'
export default {
    components: {
        goBack,
        left1,
        left2,
        center,
        // center2,
        right1,
        Map2D,
        Map3D
    },
    data() {
        return {
            stationId: this.$route.query.stationId,
            stationInfo: {},
            pageInterval: null,
            intervalNum: 15,
            intervalNumSet: 15
        }
    },
    mounted() {
		document.title = '移动能源光储充换车云一体化大屏'
		let { fromUser, scaleY } = this.$route.query
		fromUser ? sessionStorage.setItem('fromUser', fromUser) : ''
		scaleY ? localStorage.setItem('bigScreen::scaleY', scaleY) : ''

        if (this.$route.query && this.$route.query.province) {
      		console.log('省')
			this.adcode = this.$route.query.province;
			this.$EventBus.$emit('update', {
				province: this.adcode
			});
		} else if (this.$route.query && this.$route.query.city) {
      		console.log('市')
			this.adcode = this.$route.query.city;
			this.$EventBus.$emit('update', {
				city: this.adcode
			});
		} else if (this.$route.query && this.$route.query.district) {
      		console.log('区')
			this.adcode = this.$route.query.district;
			this.$EventBus.$emit('update', {
				district: this.adcode
			});
		} else {
      		console.log('省市区')
			this.type = 'nationwideSite'
			this.$EventBus.$emit('update', '');
		}

        this.pageInterval = null
        if(sessionStorage.getItem('fromUser') != 'guizhou' && sessionStorage.getItem('fromUser') != 'suzhou') {
            this.pageInterval = setInterval(() => {
                this.intervalNum--
                if(this.intervalNum < 0 ) {
                    this.$router.replace({
                        path: '/batteryCompartment',
                        query: {
                            stationId: this.stationId || 'd13e09fd3c89459789d3933008d4bcfa',
                            batteryId: this.batteryId || '08IPBN80032A3AC180200005',
                            chargingWarehouseNumber: this.chargingWarehouseNumber || ''
                        }
                    })
                }
            }, 1000)
            document.onmousemove = (event => {
                this.intervalNum = this.intervalNumSet
            })
        }
    },
    methods: {
        backData(data) {
            let { batteryId, chargingWarehouseNumber } = data
            this.batteryId = batteryId
            this.chargingWarehouseNumber = chargingWarehouseNumber
        }
    },
    destroyed() {
        clearInterval(this.pageInterval)
    }
}

</script>

<style lang="scss" scoped>
@import './components/scss/comm.scss';
.powerStation {
    position: relative;
    background: url(~@/assets/images/exposition/p-s-bg.png) no-repeat;
    background-size: 100% 100%;
    .center {
        position: absolute;
        width: 100%;
        height: 100%;
    }
}
</style>